<template>
  <div class="gd606-status-bar" type="flex">
    <el-row type="flex" class="overall-status" justify="end">
      <el-col tag="span" :span="4">
        {{ '报警状态：' | translateTo(i18nPath) }}
        <span :class="alarmStatus | alarmClass">
          {{ alarmStatus | alarmText | translateTo(i18nPath) }}
        </span>
      </el-col>
      <el-col tag="span" :span="4">
        {{ '运行状态：' | translateTo(i18nPath) }}
        <span :class="runState | runClass">
          {{ runState | runText | translateTo('device.state') }}
        </span>
      </el-col>
    </el-row>
    <!-- <div class="common-border mt-15">
      <el-row type="flex" justify="center" align="middle" class="pump-status common-border2">
        <el-col tag="span" :span="6">泵安装状态：{{ pumpStatus.install | pumpInstallText }}</el-col>
        <el-col tag="span" :span="6">泵运行状态：{{ pumpStatus.run | pumpRunText }}</el-col>
      </el-row>
    </div> -->
  </div>
</template>

<script>
import { tools } from '../utils';

export default {
  props: {
    alarmStatus: {
      type: Number,
      default: 0
    },
    runState: {
      type: Number,
      default: 0
    },
    pumpStatus: {
      type: Object,
      default: () => ({
        install: 0,
        run: 0
      })
    },
    humidity: {
      type: Number,
      required: true
    },
    temperature: {
      type: Number,
      requires: true
    }
  },
  filters: tools,
  data() {
    return {
      i18nPath: 'device.gd'
    };
  }
};
</script>

<style lang="scss">
.gd606-status-bar {
  margin: 15px 0;

  .pump-status {
    height: 50px;
  }
  .overall-status {
    font-weight: bold;
  }
  .el-col {
    font-size: 18px;
    padding-left: 20px;
    text-align: center;
  }
}
</style>
